<template>
		<!-- Footer -->
		<footer class="footer">

			<!-- Footer First Part -->
			<div class="footer-first-part">
				<div class="row hidden">
					<div class="columns small-12 medium-2 large-2">

						<!-- Footer List -->
						<ul class="footer-list">
							<li class="footer-list__item">
								<a class="footer-list__link footer-list__link_bold" href="#">Сервис</a>
							</li>
							<li class="footer-list__item">
								<a class="footer-list__link" href="#">Сервис</a>
							</li>
						</ul>
						<!-- Footer List End -->

					</div>

					<div class="columns small-12 medium-2 large-2">

						<!-- Footer List -->
						<ul class="footer-list">
							<li class="footer-list__item">
								<a class="footer-list__link footer-list__link_bold" href="#">Пациентам</a>
							</li>
							<li class="footer-list__item">
								<a class="footer-list__link" href="#">Пациентам</a>
							</li>
						</ul>
						<!-- Footer List End -->

					</div>
					<div class="columns small-12 medium-5 large-5">

						<!-- Footer List -->
						<ul class="footer-list">
							<li class="footer-list__item">
								<a class="footer-list__link footer-list__link_bold" href="#">Врачам/КлиникамКонтакты</a>
							</li>
							<li class="footer-list__item">
								<a class="footer-list__link" href="#">Врачам/КлиникамКонтакты</a>
							</li>
						</ul>
						<!-- Footer List End -->

					</div>

					<div class="columns small-12 medium-3 large-3">

						<!-- Footer List -->
						<ul class="footer-list">
							<li class="footer-list__item">
								<a class="footer-list__link footer-list__link_bold" href="#">Контакты</a>
							</li>
							<li class="footer-list__item">
								<a class="footer-list__link" href="#">Контакты</a>
							</li>
						</ul>
						<!-- Footer List End -->

					</div>

					<div class="columns small-12 medium-12 large-12">

						<!-- Footer Icons -->
						<div class="footer-icons">
							<a href="#" class="footer-icons__link">
								<div class="footer-icons__item footer-icons__item_vk">
									<i class="fa fa-vk" aria-hidden="true"></i>
								</div>
							</a>

							<a href="#" class="footer-icons__link">
								<div class="footer-icons__item footer-icons__item_fb">
									<i class="fa fa-facebook" aria-hidden="true"></i>
								</div>
							</a>

							<a href="#" class="footer-icons__link">
								<div class="footer-icons__item footer-icons__item_tw">
									<i class="fa fa-twitter" aria-hidden="true"></i>
								</div>
							</a>
						</div>
						<!-- Footer Icons End -->

					</div>

				</div>
			</div>
			<!-- Footer First Part End -->

			<!-- Footer Second Part -->
			<div class="footer-second-part">

				<div class="row">
					<div class="columns small-12 medium-12 large-12">
						<p class="footer-text">Дизайн и разработка студии <a href="http://skrymedia.com">SkryMedia</a></p>
					</div>
				</div>

			</div>
			<!-- Footer Second Part End -->

		</footer>
		<!-- Footer End -->

</template>

<script>
	export default {
		name: "Footer"
	}
</script>



// WEBPACK FOOTER //
// Footer.vue?702db23a